<template>
  <div class="applylog-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入申请人店铺或手机号查找..."
                 style="width:200px"></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option value="-11"
                    key="-11">融宝驳回申请</Option>
            <Option value="-4"
                    key="-4">融宝提现失败</Option>
            <Option value="3"
                    key="3">待平台审核</Option>
            <Option value="4"
                    key="4">平台审核通过，待后台审核</Option>
            <Option value="0"
                    key="0">后台审核通过，待公司审核</Option>
            <Option value="-3"
                    key="-4">提现失败</Option>
            <Option value="-3"
                    key="-3">公司审核不通过</Option>
            <Option value="-2"
                    key="-2">后台审核不通过</Option>
            <Option value="-1"
                    key="-1">公司审核不通过</Option>
            <Option value="1"
                    key="1">审核通过，未到账</Option>
            <Option value="2"
                    key="2">待融宝审核</Option>
            <Option value="5"
                    key="5">审核通过，已到账</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="getTx()"
                  type="info"
                  class="f-l">提现</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>

    <Modal v-model="showReview1Status"
           title="平台审核"
           @on-ok="reviewTj('reviewInfoValidate')"
           :loading="dataloading">
      <Form :model="reviewInfo"
            ref="reviewInfoValidate"
            :rules="reviewInfoValidate"
            action="javascript:void(0)">
        <FormItem label="平台审核状态"
                  label-position="status">
          <RadioGroup v-model="reviewInfo.status">
            <Radio label="4">通过</Radio>
            <Radio label="-3">不通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注"
                  label-position="platform_comment">
          <Input type="textarea"
                 v-model="reviewInfo.platform_comment"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="上传附件"
                  prop="platform_annex">
          <file-import v-model="reviewInfo.platform_annex"
                       :format="['doc','docx','xls','xlsx','pdf','pem','jpg','jpeg','png','gif','zip']"
                       :defaultList="fileListOne"
                       ref="import-filesone"></file-import>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="showReview2Status"
           title="后台审核"
           @on-ok="reviewTj('reviewInfoValidate')"
           :loading="dataloading">
      <Form :model="reviewInfo"
            ref="reviewInfoValidate"
            :rules="reviewInfoValidate"
            action="javascript:void(0)">
        <FormItem label="后台审核状态"
                  label-position="status">
          <RadioGroup v-model="reviewInfo.status">
            <Radio label="0">通过</Radio>
            <Radio label="-2">不通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注"
                  label-position="top">
          <Input type="textarea"
                 v-model="reviewInfo.comment"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <!-- <FormItem label="上传附件" prop="annex">
                    <file-import v-model="reviewInfo.annex"
                                 :format="['doc','docx','xls','xlsx','pdf','pem','jpg','jpeg','png','gif','zip']"
                                 :defaultList="fileListTwo" ref="import-filestwo"></file-import>
        </FormItem>-->
      </Form>
    </Modal>
    <Modal v-model="showReview3Status"
           title="公司审核"
           @on-ok="reviewTj('reviewInfoValidate')"
           :loading="dataloading">
      <Form :model="reviewInfo"
            ref="reviewInfoValidate"
            :rules="reviewInfoValidate"
            action="javascript:void(0)">
        <FormItem label="公司审核状态"
                  label-position="status">
          <RadioGroup v-model="reviewInfo.status">
            <Radio label="1">通过</Radio>
            <Radio label="-1">不通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注"
                  label-position="top">
          <Input type="textarea"
                 v-model="reviewInfo.company_comment"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <!-- <FormItem label="上传附件" prop="company_annex">
                    <file-import v-model="reviewInfo.company_annex" :defaultList="fileListThree"
                                 :format="['doc','docx','xls','xlsx','pdf','pem','jpg','jpeg','png','gif','zip']"
                                 ref="import-filesthree"></file-import>
        </FormItem>-->
      </Form>
    </Modal>
    <!-- 消费的弹出 -->
    <Modal v-model="showModalStatus"
           title="记录"
           :loading="loading">
      <Form action="javascript:void(0)">
        <Table border
               :columns="columns"
               ref="selection"
               :data="tablelist1"
               :loading="dataloading"></Table>
      </Form>
    </Modal>
    <Modal v-model="showStatusModalStatus"
           title="修改提现"
           @on-ok="editType('statusInfoValidate')"
           :loading="loading">
      <Form :model="statusInfo"
            action="javascript:void(0)"
            ref="statusInfoValidate"
            :rules="statusInfoValidate">
        <FormItem label="类型"
                  prop="type">
          <RadioGroup v-model="statusInfo.type">
            <Radio :label="1"
                   border>商城</Radio>
            <Radio :label="2"
                   border>云订单</Radio>
            <Radio :label="3"
                   border>城市合伙人</Radio>
            <Radio :label="4"
                   border>代理商户</Radio>
            <Radio :label="5"
                   border>用户</Radio>
            <Radio :label="6"
                   border>供应商</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="txStatus"
           title="申请提现"
           @on-ok="postTx()"
           :loading="dataloading"
           :mask-closable="false">
      <Form :model="txInfo"
            action="javascript:void(0)">
        <FormItem label="提现金额"
                  label-position="top">
          <Input v-model="txInfo.apply_money"></Input>
        </FormItem>
        <FormItem label="提现银行卡"
                  label-position="top">
          <Input v-model="txInfo.bank_card"></Input>
        </FormItem>
        <FormItem label="开户行"
                  label-position="top">
          <Input v-model="txInfo.opening_bank"></Input>
        </FormItem>
        <FormItem label="开户名称"
                  label-position="top">
          <Input v-model="txInfo.fullname"></Input>
        </FormItem>
        <FormItem label="银行卡类型"
                  label-position="top">
          <Select v-model="txInfo.typename"
                  clearable
                  style="width:80px"
                  placeholder="银行卡类型...">
            <Option v-for="item in bankCardTypeList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="商户号"
                  label-position="top">
          <Select v-model="txInfo.tx_mchid"
                  clearable
                  style="width:80px"
                  placeholder="商户号...">
            <Option v-for="item in mchTypeList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <!--可以提现的订单-->
  </div>
</template>

<script>
import FileImport from "../common/fileimport";

export default {
  name: "applylog-list",
  data () {
    return {
      tradesman: {},
      loading: true,
      dataloading: true,
      showStatusModalStatus: false,
      title: "",
      txInfo: {
        bank_card: 0,
        apply_money: 0
      },
      bankCardTypeList: [
        { id: 1, name: "私" },
        { id: 2, name: "公" }
      ],
      mchTypeList: [
        { id: 1, name: "B2C" },
        { id: 6, name: "B2B" }
      ],
      txStatus: false,
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        status: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          width: 90
        },
        {
          title: "申请人",
          key: "name",
          width: 150
        },
        {
          title: "类型",
          key: "apply_type",
          width: 90
        },
        {
          title: "申请金额",
          key: "apply_money",
          width: 100
        },
        {
          title: "服务费",
          key: "service_money",
          width: 100
        },
        {
          title: "实际到账",
          key: "money",
          width: 150
        },
        {
          title: "银行卡",
          key: "bankcard",
          width: 150
        },
        {
          title: "批次号",
          key: "batch_no",
          width: 150
        },
        {
          title: "申请时间",
          key: "created_at",
          width: 150
        },
        {
          title: "审核状态",
          // key: 'created_at',
          minWidth: 150,
          render: (h, params) => {
            var s_name = new Array();
            s_name[-11] = "融宝驳回申请";
            s_name[-4] = "提现申请失败";
            s_name[-3] = "平台审核不通过";
            s_name[-2] = "后台审核不通过";
            s_name[-1] = "公司审核不通过";
            s_name[0] = "待公司审核";
            s_name[1] = "审核通过，未到账";
            s_name[2] = "待融宝审核";
            s_name[5] = "审核通过，已到账";
            s_name[3] = "待平台审核";
            s_name[4] = "待后台审核";
            // [-3 => '平台审核不通过'];
            return h("div", [h("span", {}, s_name[params.row.status])]);
          }
        },
        {
          title: "平台审核备注",
          key: "platform_comment",
          width: 150
        },
        {
          title: "后台审核备注",
          key: "comment",
          width: 150
        },
        {
          title: "公司审核备注",
          key: "company_comment",
          width: 150
        },
        {
          title: "融宝驳回备注",
          key: "rb_comment",
          width: 150
        },
        {
          title: "平台附件",
          key: "company_comment",
          width: 100,
          render: (h, params) => {
            if (
              params.row.platform_annex == "" ||
              params.row.platform_annex == null
            ) {
              return h(
                "tag",
                {
                  props: {
                    color: "red"
                  }
                },
                "未上传"
              );
            } else {
              return h(
                "a",
                {
                  attrs: {
                    href: params.row.platform_annex,
                    target: "_black"
                  }
                },
                "下载"
              );
            }
          }
        },
        // {
        //     title: '后台附件',
        //     key: 'company_comment',
        //     width: 100,
        //     render: (h, params) => {
        //         if (params.row.annex == '' || params.row.annex == null) {
        //             return h('tag',
        //                 {
        //                     props: {
        //                         color: 'red',
        //                     }
        //                 },
        //                 '未上传')
        //         } else {
        //             return h('a', {
        //                 attrs: {
        //                     href: params.row.annex,
        //                     target: '_black'
        //                 }
        //             }, '下载')
        //         }
        //     }
        // },
        // {
        //     title: '公司附件',
        //     key: 'company_comment',
        //     width: 100,
        //     render: (h, params) => {
        //         if (params.row.company_annex == '' || params.row.company_annex == null) {
        //             return h('tag',
        //                 {
        //                     props: {
        //                         color: 'red',
        //                     }
        //                 },
        //                 '未上传')
        //         } else {
        //             return h('a', {
        //                 attrs: {
        //                     href: params.row.company_annex,
        //                     target: '_black'
        //                 }
        //             }, '下载')
        //         }

        //     }
        // },
        {
          title: "操作",
          key: "action",
          width: 240,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  // style: {
                  //     marginRight: '8px'
                  // },
                  style: {
                    marginRight: "8px",
                    display:
                      params.row.status == 0 ||
                        params.row.status == 3 ||
                        params.row.status == 4
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.typeDetail(params.row.id, params.row.type);
                    }
                  }
                },
                "类型"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      this.role_ids.indexOf(9) > -1 && params.row.status == 3
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 9);
                    }
                  }
                },
                "平台财务审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      this.role_ids.indexOf(10) > -1 && params.row.status == 0
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 10);
                    }
                  }
                },
                "公司财务审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      this.role_ids.indexOf(1) > -1 && params.row.status == 4
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "后台财务审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      columns: [
        {
          title: "原因",
          key: "result"
        },
        {
          title: "转账时间",
          key: "updated_at"
        }
      ],
      reviewOrder: {},
      tablelist: [],
      tablelist1: [],
      showModalStatus: false,
      showReview1Status: false,
      showReview2Status: false,
      showReview3Status: false,
      tradesmanValidate: {},
      role_ids: [],
      role_id: [],
      fileListOne: [],
      fileListTwo: [],
      fileListThree: [],
      reviewInfo: {
        status: "",
        comment: "",
        platform_comment: "",
        company_comment: ""
      },
      reviewInfoValidate: {
        status: [{ required: true, message: "审核必须填写", trigger: "blur" }]
      },
      statusInfo: {
        type: ""
      },
      statusInfoValidate: {}
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    FileImport
  },
  methods: {
    getTableList: function () {
      this.$api.applylog
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.role_ids = res.result.role_ids;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 详情
    detail (index) {
      this.tradesman.id = index;
      this.$api.applylog.detail({ apply_id: index }).then(res => {
        if (res.code == 200) {
          this.showModalStatus = !this.showModalStatus;
          this.tablelist1 = res.result;
        }
      });
    },
    typeDetail (id, type) {
      this.statusInfo = {
        type: type,
        id: id
      };
      this.showStatusModalStatus = !this.showStatusModalStatus;
    },
    editType (name) {
      console.log("111");
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.applylog
            .edittype({ id: this.statusInfo.id, type: this.statusInfo.type })
            .then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showStatusModalStatus = !this.showStatusModalStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 审核
    review (index, role_id) {
      if (role_id == 9) {
        this.showReview1Status = !this.showReview1Status;
      }
      if (role_id == 10) {
        this.showReview3Status = !this.showReview3Status;
      }
      if (role_id == 1) {
        this.showReview2Status = !this.showReview2Status;
      }
      this.reviewInfo = {
        status: "",
        comment: "",
        platform_comment: "",
        company_comment: ""
      };

      this.fileListOne = [];
      this.fileListTwo = [];
      this.fileListThree = [];
      this.$api.applylog.moneydetail({ id: index }).then(res => {
        if (res.code == 200) {
          this.reviewInfo = res.result;

          if (res.result.platform_annex && res.result.platform_annex != null) {
            this.fileListOne.push({
              url: res.result.platform_annex,
              name: res.result.platform_annex
            });
          }

          if (res.result.annex && res.result.annex != null) {
            this.fileListTwo.push({
              url: res.result.annex,
              name: res.result.annex
            });
          }

          if (res.result.company_annex && res.result.company_annex != null) {
            this.fileListThree.push({
              url: res.result.company_annex,
              name: res.result.company_annex
            });
          }
        }
      });
      this.tradesman.id = index;
      this.role_id = role_id;
    },
    // 添加
    reviewTj: function (name) {
      if (
        !(
          this.$refs["import-filesone"].resList != undefined &&
          this.$refs["import-filesone"].resList.length
        )
      ) {
        this.reviewInfo.platform_annex = "";
      } else {
        this.reviewInfo.platform_annex = this.$refs[
          "import-filesone"
        ].resList[0].url;
      }
      // if (!(this.$refs['import-filestwo'].resList != undefined && this.$refs['import-filestwo'].resList.length)) {
      //     this.reviewInfo.annex = '';
      // } else {
      //     this.reviewInfo.annex = this.$refs['import-filestwo'].resList[0].url;
      // }
      // if (!(this.$refs['import-filesthree'].resList != undefined && this.$refs['import-filesthree'].resList.length)) {
      //     this.reviewInfo.company_annex = '';
      // } else {
      //     this.reviewInfo.company_annex = this.$refs['import-filesthree'].resList[0].url;
      // }
      this.$api.applylog
        .review({
          apply_id: this.tradesman.id,
          status: this.reviewInfo.status,
          comment: this.reviewInfo.comment,
          platform_comment: this.reviewInfo.platform_comment,
          company_comment: this.reviewInfo.company_comment,
          role_id: this.role_id,
          // annex: this.reviewInfo.annex,
          platform_annex: this.reviewInfo.platform_annex
          // company_annex: this.reviewInfo.company_annex,
        })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status
      };
      this.$api.applylog.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.role_ids = res.result.role_ids;
          this.pages.total = res.result.total;
        }
      });
      return;
    },
    getTx () {
      this.txStatus = !this.txStatus;
      this.txInfo = {};
    },
    postTx (row) {
      this.$api.applylog
        .admintx(
          this.txInfo
        )
        .then(res => {
          if (res.code == 200) {
            // this.paypwdForm = res.result;
            console.log(333);
          }
        });
    },
  }
};
</script>